import * as apiUtils from "@/utils/apiUtils"

export default {
  namespaced: true,
  // -----------------------------------------------------------------
  state: {},
  // -----------------------------------------------------------------
  getters: {},
  // -----------------------------------------------------------------
  mutations: {},
  // -----------------------------------------------------------------
  actions: {
    // Collaborators
    getCollaborators: context => {
      var bid = context.rootGetters["bizes/bid"]()
      var path = "/bizes/" + bid + "/collaborators"
      return apiUtils.get(path)
    },
    getInvitations: context => {
      var bid = context.rootGetters["bizes/bid"]()
      var path = "/bizes/" + bid + "/collaborator-invitations"
      return apiUtils.get(path)
    },
    inviteCollaborator: (context, { name, email }) => {
      var bid = context.rootGetters["bizes/bid"]()
      var path = "/bizes/" + bid + "/collaborators/invite"
      return apiUtils.post(path, { name, email })
    },
    createCollaborator: (context, { bid, invitationToken, name, email, password }) => {
      var path = "/bizes/" + bid + "/collaborators"
      return apiUtils.post(path, {
        invitationToken,
        name,
        email,
        password
      })
    },
    joinCollaborator: (context, { bid, invitationToken }) => {
      var path = "/bizes/" + bid + "/collaborators/join"
      return apiUtils.post(path, { invitationToken })
    },
    deleteCollaborator: (context, id) => {
      var bid = context.rootGetters["bizes/bid"]()
      var path = "/bizes/" + bid + "/collaborators/" + id
      return apiUtils.delete(path)
    },
    cancelInvitation: (context, { email }) => {
      var bid = context.rootGetters["bizes/bid"]()
      var path = "/bizes/" + bid + "/collaborators/cancel"
      return apiUtils.post(path, { email })
    }
  }
}
